/**
 * @author Sai Prasad
 * @class WalkthroughChecklistItems
 */

import React from 'react';
import Checkbox from "../../Checkbox"

const WalkthroughChecklistItems = ({
  checkList,
  edit,
  handleItemChecked
}) => {
  return (
    <div class="chack_box_main masterChecklist">
      <div class="chack_box_info">
        <div class="title_chack_box">
          <h3>Checklist</h3>
        </div>
        <div class="checklist">
          {checkList.map(
            (item, i) => (
              <Checkbox
                label={item.description}
                value={item.ischecked}
                onChange={() =>
                  edit ? handleItemChecked(item) : null
                }
              />
            )
          )}
        </div>
      </div>
    </div>
  )
}

export default WalkthroughChecklistItems;